import { render, staticRenderFns } from "./RegulationScreen.vue?vue&type=template&id=6c533802&scoped=true"
import script from "./RegulationScreen.vue?vue&type=script&lang=js"
export * from "./RegulationScreen.vue?vue&type=script&lang=js"
import style0 from "./RegulationScreen.vue?vue&type=style&index=0&id=6c533802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c533802",
  null
  
)

export default component.exports